export type SocialLoginProvider = "google" | "facebook" | "github" | "twitter";

const providerLabels: Record<SocialLoginProvider, string> = {
  google: "Google",
  facebook: "Facebook",
  github: "GitHub",
  twitter: "X",
};

export const getSocialLoginLabel = (provider: SocialLoginProvider) => providerLabels[provider];

export const getSocialLoginUrl = (provider: SocialLoginProvider) => {
  const backendBaseUrl = (process.env.REACT_APP_API_URL || window.location.origin).replace(/\/$/, "");
  return `${backendBaseUrl}/oauth2/authorization/${provider}`;
};